var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text',{class:Number.parseInt(_vm.vehicle.properties.routeTag) ? 'bus' : 'trolley',style:(_vm.styleObject),attrs:{"x":_vm.xPosition,"y":_vm.yPosition,"route":_vm.vehicle.properties.routeTag}},[_vm._v(_vm._s(Number.parseInt(_vm.vehicle.properties.routeTag) ? '🚌' : '🚋'))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e6443e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vehicle.vue
// module id = null
// module chunks = 